module.exports = __webpack_public_path__ + "img/datalogfarmmap.afc625ec.png";